import React, { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import useAcademy from "../../../../hooks/useAcademy";

export default function DeleteAcademyModal({
  setOpenDeleteModal,
  modalName,
  name,
  createdBy,
  onTrigger,
  id,
  subCategory,
}) {
  const [loading, setLoading] = useState(false);
  const { deleteAcademy } = useAcademy();

  const handleDelete = async () => {
    let resource = "";
    if (modalName === "Training") {
      resource = "training";
      try {
        await deleteAcademy(setLoading, id, resource);
        setOpenDeleteModal(false);
        void onTrigger();
      } catch (error) {
        console.error("Failed to delete training:", error);
      }
    } else if (modalName === "Module") {
      resource = "trainingModule";
      await deleteAcademy(setLoading, id, resource);
      void onTrigger();
    } else if (modalName === "Video") {
      resource = "trainingVideo";
      await deleteAcademy(setLoading, id, resource);
      void onTrigger();
    } else if (modalName === "Banner") {
      resource = "banner";
      await deleteAcademy(setLoading, id, resource);
      void onTrigger();
    }
  };
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div
        className="bg-white w-full max-w-md relative rounded-md shadow-lg"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex justify-between items-center bg-blue-600 text-white px-6 py-4">
          <h2 className="text-lg text-white font-semibold">
            Delete {modalName}
          </h2>
          <button
            onClick={() => setOpenDeleteModal(false)}
            className="text-white hover:text-gray-200"
          >
            <CloseIcon />
          </button>
        </div>

        <div className="p-6 space-y-4 w-full">
          <span className="text-black">
            This action cannot be undone. Are you sure you want to permanently
            delete this item?
          </span>

          <div className="space-y-2">
            <div className="flex items-center">
              <span className="w-1/3 text-sm font-medium text-gray-600">
                Name:
              </span>
              <span className="text-sm text-gray-900">{name}</span>
            </div>
            {modalName === "Video" || modalName === "Banner" ? null : (
              <div className="flex items-center">
                <span className="w-1/3 text-sm font-medium text-gray-600">
                  Sub-Categories:
                </span>
                <span className="text-sm text-gray-900">
                  {subCategory < 2
                    ? `${subCategory} ${
                        modalName === "Module" ? "Video" : "Module"
                      }`
                    : `${subCategory} ${
                        modalName === "Module" ? "Videos" : "Modules"
                      }`}
                </span>
              </div>
            )}
            {modalName === "Banner" ? null : (
              <div className="flex items-center">
                <span className="w-1/3 text-sm font-medium text-gray-600">
                  Created By:
                </span>
                <span className="text-sm text-gray-900">{createdBy}</span>
              </div>
            )}
          </div>
          <hr className="border border-b border-gray-200" />

          <div className="grid grid-cols-4 gap-2 mt-6 w-full">
            <button
              onClick={() => setOpenDeleteModal(false)}
              className="col-span-1 text-[#2E2E32] font-medium px-4 py-2 border border-gray-100 rounded-md"
            >
              Close
            </button>
            <button
              onClick={handleDelete}
              disabled={loading}
              className="bg-[#B52026] col-span-3 text-white text-center font-bold py-2 rounded-md hover:bg-red-600"
            >
              {loading ? "Deleting.." : "Confirm"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
